/**
 * @flow
 */

import React, { useState, useCallback } from 'react';
import { Modal } from '../../../../components';

import Navigation from './Navigation';
import EditProduct from '../../containers/details/EditProduct';

import type { NavigationItems, ModalDialog, Product } from './Navigation';

type ProductDetailsProps = {
    product: Product,
} & ModalDialog;

function ProductDetails({ product, trigger, onClose, open }: ProductDetailsProps) {
    const [selectedItem, setSelectedItem] = useState('editProduct');

    const onItemClick = useCallback((e, { name }) => {
        setSelectedItem(name);
    }, []);

    return (
        <Modal onClose={onClose} open={open} trigger={trigger}>
            <Modal.Header>
                {product.name}
            </Modal.Header>
            <Navigation selectedItem={selectedItem} onItemClick={onItemClick} />
            {selectedItem === 'editProduct' && (
                <EditProduct product={product} onClose={onClose} />
            )}
        </Modal>
    );
}

export default ProductDetails;
